"use client";

import { trackEvent } from "@/utils/gtm";

type Props = {
  jobTitle: string;
};

export default function ApplyNowButton({ jobTitle }: Props) {
  return (
    <a
      href="/contact-us"
      onClick={() => trackEvent("Jobs", "apply_click", jobTitle, "/jobs")}
      className="inline-flex mt-5 items-center justify-center rounded-lg bg-[#1B61FF] px-5 py-2.5 text-sm font-bold text-white hover:bg-blue-700 transition-colors"
    >
      Apply Now
    </a>
  );
}
